import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

/**
 * „Passt dazu“ im Warenkorb-Drawer (snippets/cart-upsell.liquid).
 * Legt einen Artikel direkt in den Warenkorb; der Drawer rendert sich über das CartAddEvent neu.
 */
class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = async (event) => {
    const button = event.target instanceof Element ? event.target.closest('button[data-variant-id]') : null;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.disabled = true;
    button.classList.add('is-loading');

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : null))
      .filter(Boolean);

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    // Versteckte Eigenschaft (Unterstrich) für die Auswertung in den Bestellungen
    formData.append('properties[_quelle]', 'warenkorb-empfehlung');
    formData.append('sections', sectionIds.join(','));

    try {
      const response = await fetch(Theme.routes.cart_add_url, fetchConfig('javascript', { body: formData }));
      const result = await response.json();
      if (result.status) throw new Error(result.description || result.message);

      const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
        r.json()
      );

      document.dispatchEvent(
        new CartAddEvent({}, variantId, {
          source: 'cart-upsell',
          itemCount: cart.item_count,
          productId: String(result.product_id ?? ''),
          sections: result.sections,
        })
      );
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  };
}

if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', CartUpsell);
}
